import React from "react";
import dynamic from "next/dynamic";
import { FadeInSection } from "@/components/webview/games/core/FadeInSectionWebview";

const LazyAudioToHapticWhatIsWebView = dynamic<{ className?: string }>(
  () => import("./AudioToHapticWhatIsWebView"),
  {
    ssr: false,
  },
);

const LazyAudioToHapticFindThePerfectProfileWebView = dynamic<{
  className?: string;
}>(() => import("./AudioToHapticFindThePerfectProfileWebView"), {
  ssr: false,
});

const LazyAudioToHapticFAQWebView = dynamic<{ className?: string }>(
  () => import("./AudioToHapticFaqWebView"),
  {
    ssr: false,
  },
);

const AudioToHapticsLazySectionsWebView = () => {
  return (
    <section className="flex flex-col gap-[38px] bg-black pb-[38px]">
      <FadeInSection>
        <LazyAudioToHapticWhatIsWebView />
      </FadeInSection>
      <FadeInSection>
        <LazyAudioToHapticFindThePerfectProfileWebView />
      </FadeInSection>

      <FadeInSection>
        <LazyAudioToHapticFAQWebView />
      </FadeInSection>
    </section>
  );
};

export default AudioToHapticsLazySectionsWebView;
